<script setup lang="ts">
import { computed, type Component } from "vue";
import { Tooltip } from "@/components/ui/tooltip";
import { cardSubtype, cardTypeMeta } from "../constants";

interface TypedCard {
  card_type?: string;
  content?: { sub_type?: string };
}

// Resolves the icon and label from the card's own type by default. Question cards pass
// them explicitly — their label depends on the question kind, not the card type.
const props = withDefaults(
  defineProps<{
    card?: TypedCard | null;
    icon?: Component | null;
    label?: string;
  }>(),
  { card: null, icon: null, label: "" },
);

const meta = computed(() => cardTypeMeta(cardSubtype(props.card) || props.card?.card_type));
const resolvedIcon = computed<Component | null>(() => props.icon || meta.value?.icon || null);
const resolvedLabel = computed(() => props.label || meta.value?.label || "");
</script>

<template>
  <Tooltip v-if="resolvedIcon" :content="resolvedLabel" :delay-duration="500">
    <component :is="resolvedIcon" class="h-3.5 w-3.5 shrink-0 text-muted-foreground" />
  </Tooltip>
</template>
